import { render, staticRenderFns } from "./toBind.vue?vue&type=template&id=53be8438&scoped=true&"
import script from "./toBind.vue?vue&type=script&lang=js&"
export * from "./toBind.vue?vue&type=script&lang=js&"
import style0 from "./toBind.vue?vue&type=style&index=0&id=53be8438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be8438",
  null
  
)

export default component.exports